import MenuItemStandardCost from 'records/MenuItemStandardCost';
import Base from 'records/Base';

import {
  MENU_ITEM_STANDARD_COST_ASYNC_ACTION_START,
  MENU_ITEM_STANDARD_COST_ASYNC_ACTION_ERROR,
  MENU_ITEM_STANDARD_COST_ASYNC_ACTION_UPDATE_SUCCESS,
  MENU_ITEM_STANDARD_COST_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_STANDARD_COST_RESET_STATE,
} from 'actions/menuItemStandardCost';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new MenuItemStandardCost(),
});

const actionsMap = {
  [MENU_ITEM_STANDARD_COST_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_STANDARD_COST_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_STANDARD_COST_ASYNC_ACTION_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new MenuItemStandardCost(action.data),
    });
  },
  [MENU_ITEM_STANDARD_COST_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ITEM_STANDARD_COST_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItemStandardCost(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
